import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, PageHeader, SectionLabel } from "@/components/Reveal";
import { SERVICES, IMAGES } from "@/data/content";

const ServiceGrid = () => (
  <section className="py-24 px-6 sm:px-12" data-testid="services-grid">
    <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-border border border-border">
      {SERVICES.map((s, i) => (
        <Reveal key={s.title} delay={(i % 3) * 0.08} className="bg-white">
          <div className="p-10 h-full group relative overflow-hidden" data-testid={`service-card-${i}`}>
            <div className="absolute top-0 left-0 w-full h-[3px] bg-gold scale-x-0 origin-left group-hover:scale-x-100 transition-transform duration-500" />
            <p className="font-serif text-lg text-gold/60">{String(i + 1).padStart(2, "0")}</p>
            <h3 className="mt-5 font-serif text-2xl text-ink group-hover:text-gold-dark transition-colors duration-300">
              {s.title}
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-slate-500">{s.desc}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);

const ApproachTeaser = () => (
  <section className="bg-white border-y border-border py-24 px-6 sm:px-12" data-testid="approach-teaser">
    <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-6">
        <Reveal>
          <SectionLabel>Our Approach</SectionLabel>
          <h2 className="mt-6 font-serif text-3xl sm:text-4xl tracking-tight text-ink">
            Built on data, domain expertise and technology.
          </h2>
          <p className="mt-6 text-base leading-relaxed text-slate-600">
            A structured, research-driven method — Understand, Research, Analyze, Evaluate, Deliver —
            ensuring credible and defensible valuations on every engagement.
          </p>
          <Link
            to="/approach"
            data-testid="approach-teaser-link"
            className="mt-8 inline-flex items-center gap-2 text-xs tracking-[0.25em] uppercase font-semibold text-gold hover:text-ink transition-colors duration-300"
          >
            See Our Method <ArrowRight size={14} />
          </Link>
        </Reveal>
      </div>
      <div className="lg:col-span-6">
        <Reveal delay={0.15}>
          <div className="clipped-frame">
            <img src={IMAGES.blueprints} alt="Architectural blueprints on a desk" className="w-full h-[380px] object-cover" />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default function Services() {
  return (
    <>
      <PageHeader
        label="Our Services"
        lines={["Comprehensive valuation", "& advisory services."]}
        sub="Delivered with the highest standards of accuracy, transparency and professionalism — across asset classes and engagement types."
      />
      <ServiceGrid />
      <ApproachTeaser />
    </>
  );
}
